<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">404</h1>
            <h4 class="pt-3">Oops! Você está perdido.</h4>
            <p class="text-muted">
              A página que você procura não existe. Clique <router-link :to="{name: 'Dashboard'}">aqui</router-link> para voltar.
            </p>
          </div>
          <div class="input-prepend input-group">
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>


// WEBPACK FOOTER //
// src/views/pages/Page404.vue